import styled from 'styled-components';
// lib
import palette from 'lib/styles/palette';
import * as styles from 'lib/styles/styles';

const ControlBtn = ({ message, onClick }: Props) => {
  return <Btn onClick={() => onClick()}>{message }
  {/* return <Btn onClick={() => onClick()}>{message === 'সেটিংস'?<I className="material-icons">settings</I>:message} */}
  </Btn>;
}

const Btn = styled.button`
  font-size: 1rem;
  font-weight: 600;
  height: 100%;
  padding: 0 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: .1s ${styles.transition};
  outline: none;

  &:focus, &:hover {
    color: ${palette.blue4};
  }

  &:first-child {
    margin-left: 8px;
  }
`;

const I = styled.i`
 &:focus, &:hover {
    color: ${palette.blue4};
  }
`

interface Props {
  message: JSX.Element;
  onClick: (value?: boolean) => void;
}

export default ControlBtn